import Seo from "@/components/seo/Seo";
import JsonLd from "@/components/seo/JsonLd";
import { productLd, faqPageLd, breadcrumbLd } from "@/data/schema";
import { FAQ } from "@/data/site";
import PageHero from "@/components/layout/PageHero";
import Pricing from "@/components/home/Pricing";
import RoiCalculator from "@/components/pricing/RoiCalculator";
import Faq from "@/components/home/FAQ";
import CtaBand from "@/components/layout/CtaBand";

export default function PricingPage() {
    return (
        <>
            <Seo
                title="Cennik"
                path="/pricing"
                description="Cennik Groszownika: plan FREE na zawsze, PRO za 34,99 zł/mc z pełnym AI oraz Enterprise dla biur. Sprawdź kalkulator ROI i policz swoje oszczędności."
            />
            <JsonLd data={productLd} />
            <JsonLd data={faqPageLd(FAQ.slice(0, 4))} />
            <JsonLd data={breadcrumbLd([{ name: "Start", path: "/" }, { name: "Cennik", path: "/pricing" }])} />
            <PageHero
                eyebrow="Cennik"
                title="Płać mniej, zyskuj więcej"
                subtitle="Zacznij za darmo. Przejdź na PRO za 34,99 zł, gdy firma rośnie. Bez ukrytych opłat."
            />
            <Pricing />
            <section className="pb-4">
                <div className="container-gr">
                    <RoiCalculator />
                </div>
            </section>
            <Faq />
            <CtaBand title="Policz, przekonaj się, pobierz" subtitle="Kalkulator pokazał liczby. Pozostała część zajmuje kilka chwil w aplikacji." />
        </>
    );
}
